import React from 'react';
import ReactTooltip from 'react-tooltip';

const CopyToClipboard = (props) => {
  const { text } = props;

  return (
    <>
      <i
        data-tip="Copied"
        data-event="click focus"
        data-for={`copyIcon_${text}`}
        id={`copyIcon_${text}`}
        className="pi pi-fw pi-copy ml-1 copy-icon"
      />
      <ReactTooltip
        id={`copyIcon_${text}`}
        globalEventOff="click"
        afterShow={() => {
          navigator.clipboard.writeText(text);
          setTimeout(() => {
            ReactTooltip.hide();
          }, 500);
        }}
      />
    </>
  );
};

export default CopyToClipboard;
